import type React from "react";

interface ReservationStatusCardProps {
	reservationCount: number;
	attendeeCount: number;
	maximumAttendees: number;
	primaryColor?: string;
	primaryLightColor?: string;
}

export const ReservationStatusCard: React.FC<ReservationStatusCardProps> = ({
	reservationCount,
	attendeeCount,
	maximumAttendees,
	primaryColor = "#99CA29",
	primaryLightColor = "#fdfff0",
}) => {
	const reservationRate =
		maximumAttendees > 0
			? Math.round((reservationCount / maximumAttendees) * 100)
			: 0;
	const attendeeRate =
		maximumAttendees > 0
			? Math.round((attendeeCount / maximumAttendees) * 100)
			: 0;

	return (
		<div style={{ marginBottom: "16px" }}>
			<div
				style={{
					backgroundColor: primaryLightColor,
					color: primaryColor,
					padding: "8px 16px",
					textAlign: "center",
					fontSize: "18px",
					fontWeight: "bold",
					marginBottom: "16px",
					borderRadius: "4px",
				}}
			>
				予約状況
			</div>
			<div
				style={{
					display: "flex",
					borderRadius: "4px",
					overflow: "hidden",
					border: `1px solid ${primaryColor}`,
				}}
			>
				<div
					style={{
						flex: 1,
						padding: "12px",
						textAlign: "center",
						borderRight: `1px solid ${primaryColor}`,
					}}
				>
					<div
						style={{
							fontSize: "14px",
							marginBottom: "4px",
							color: primaryColor,
						}}
					>
						予約人数
					</div>
					<div
						style={{
							fontSize: "24px",
							fontWeight: "bold",
							color: primaryColor,
						}}
					>
						{reservationCount}人
					</div>
				</div>
				<div style={{ flex: 1, padding: "12px", textAlign: "center" }}>
					<div
						style={{
							fontSize: "14px",
							marginBottom: "4px",
							color: primaryColor,
						}}
					>
						参加者数
					</div>
					<div
						style={{
							fontSize: "24px",
							fontWeight: "bold",
							color: primaryColor,
						}}
					>
						{attendeeCount}人
					</div>
				</div>
			</div>
			<div
				style={{
					backgroundColor: primaryColor,
					color: "white",
					padding: "8px 16px",
					textAlign: "center",
					borderRadius: "0 0 4px 4px",
				}}
			>
				<span style={{ marginRight: "8px" }}>参加可能最大人数</span>
				<span style={{ fontWeight: "bold", fontSize: "18px" }}>
					{maximumAttendees}人
				</span>
			</div>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					marginTop: "24px",
					gap: "24px",
				}}
			>
				<CircularProgress
					percentage={reservationRate}
					label="予約率"
					color={primaryColor}
				/>
				<CircularProgress
					percentage={attendeeRate}
					label="参加者率"
					color={primaryColor}
				/>
			</div>
		</div>
	);
};

interface CircularProgressProps {
	percentage: number;
	label: string;
	color: string;
	size?: number;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
	percentage,
	label,
	color,
	size = 100,
}) => {
	const strokeWidth = 8;
	const radius = (size - strokeWidth) / 2;
	const circumference = radius * 2 * Math.PI;
	const offset = circumference - (percentage / 100) * circumference;

	return (
		<div
			style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
		>
			<svg
				width={size}
				height={size}
				role="img"
				aria-label={`${label}: ${percentage}%`}
			>
				<title>
					{label}: {percentage}%
				</title>
				<circle
					stroke="#e5e7eb"
					fill="transparent"
					strokeWidth={strokeWidth}
					r={radius}
					cx={size / 2}
					cy={size / 2}
				/>
				<circle
					stroke={color}
					fill="transparent"
					strokeWidth={strokeWidth}
					strokeLinecap="round"
					r={radius}
					cx={size / 2}
					cy={size / 2}
					style={{
						strokeDasharray: circumference,
						strokeDashoffset: offset,
						transformOrigin: "center",
						transform: "rotate(-90deg)",
						transition: "stroke-dashoffset 0.5s ease-out",
					}}
				/>
				<text
					x="50%"
					y="50%"
					dominantBaseline="middle"
					textAnchor="middle"
					style={{ fill: color, fontSize: "14px" }}
				>
					{label}
				</text>
				<text
					x="50%"
					y="65%"
					dominantBaseline="middle"
					textAnchor="middle"
					style={{ fill: "#374151", fontSize: "16px", fontWeight: "bold" }}
				>
					{percentage}%
				</text>
			</svg>
		</div>
	);
};
